import {Globe} from 'lucide-react'
import {Button} from '@/components/ui/button'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {useTranslation} from 'react-i18next'
import {changeLanguage} from '@/i18n'
import {useAppConfig} from '@/hooks/use-app-config'

const LANGUAGE_NAMES: Record<string, string> = {
    en: 'English',
    de: 'Deutsch',
}

export function LanguageSwitcher() {
    const {i18n} = useTranslation()
    const {supportedLocales} = useAppConfig()
    const currentLang = i18n.language

    if (supportedLocales.length <= 1) return null

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="sm" className="gap-2" data-testid="btn-language-switcher">
                    <Globe className="h-4 w-4"/>
                    <span className="hidden sm:inline">{LANGUAGE_NAMES[currentLang] ?? currentLang}</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                {supportedLocales.map((locale) => (
                    <DropdownMenuItem
                        key={locale}
                        data-testid={`btn-language-${locale}`}
                        onClick={() => changeLanguage(locale)}
                        className={currentLang === locale ? 'bg-accent' : ''}
                    >
                        {LANGUAGE_NAMES[locale] ?? locale}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
